import { Button } from "antd";
import { ReactElement, ReactNode } from "react";
import { Link } from "react-router-dom";
import { LoginFormLayout } from "../../../layouts/LoginFormLayout/LoginFormLayout";
import { AgentLoginForm } from "../forms/AgentLoginForm";
import { ClientLoginForm } from "../forms/ClientLoginForm";
import { useLoginFormVariant } from "../hooks/useLoginFormVariant";
import { TRoles } from "../types/types";

import classes from "./LoginComponent.module.css";

interface IModeButtonInterface {
  value: TRoles;
  children: ReactNode;
}

const modeButtonsParams: IModeButtonInterface[] = [
  { value: "client", children: "Клиент" },
  { value: "agent", children: "Агент" },
];

const MODEFORMS = { client: <ClientLoginForm />, agent: <AgentLoginForm /> };

export function LoginComponent(): ReactElement {
  const { loginVariant, handleLoginVariant } = useLoginFormVariant();

  return (
    <LoginFormLayout name="Вход">
      <div className={classes.toggleModeContainer}>
        {modeButtonsParams.map((item) => {
          return (
            <Button
              size="large"
              className={classes.modeTogglers}
              onClick={() => {
                handleLoginVariant(item.value);
              }}
              variant={item.value === loginVariant ? "solid" : "outlined"}
              color={item.value === loginVariant ? "primary" : "default"}
              key={item.value}
            >
              {item.children}
            </Button>
          );
        })}
      </div>

      <div className={classes.loginFormMain}>
        {MODEFORMS[loginVariant]}

        <Link className={classes.regLink} to="/selectRegistration">
          <Button size="large" className={classes.regLinkBtn}>
            Зарегистрироваться
          </Button>
        </Link>
      </div>
    </LoginFormLayout>
  );
}
